// src/App.jsx
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import StudentsPage from "./pages/StudentsPage";
import StudentDetailPage from "./pages/StudentDetailPage";
import ClothesManagement from "./pages/ClothesManagement";
import BooksManagement from "./pages/BooksManagement";
import ClassesPage from "./pages/ClassesPage";
import ClassDetailPage from "./pages/ClassDetailPage";
import AccountingPage from "./pages/AccountingPage";
import ManagementPage from "./pages/UserManagementPage";
import IncompleteFeesPage from "./pages/IncompleteFeesPage"; 
import NotFoundPage from "./pages/NotFoundPage";
import StaticFeesPage from "./pages/StaticFeesPage";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import { UserRole } from "./types";
import TeachersPage from "./pages/TeachersPage";
import TransportPage from "./pages/TransportPage";
function App() {
  return (
    <AuthProvider>
      {/* Single toast container for the whole app. Two competing libraries
          (react-toastify + react-hot-toast) used to be mounted here; their
          overlays overlapped at top-right and the Books / Clothes /
          Accounting toasts were rendered behind the other library's
          container. Now unified on react-toastify. */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
      />

      <Router>
        <Routes>
          {/* Login Page */}
          <Route path="/login" element={<LoginPage />} />

          {/* All protected routes inside Layout */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            {/* Dashboard (Home) */}
            <Route index element={<DashboardPage />} />

            {/* الطلاب */}
            <Route
              path="students"
              element={
                <ProtectedRoute
                  roles={[UserRole.OWNER, UserRole.SECRETARY, UserRole.ACCOUNTANT]}
                >
                  <StudentsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="students/:serialNumber"
              element={
                <ProtectedRoute
                  roles={[
                    UserRole.OWNER,
                    UserRole.SECRETARY,
                    UserRole.ACCOUNTANT,
                  ]}
                >
                  <StudentDetailPage />
                </ProtectedRoute>
              }
            />

            {/* الشعب */}
            <Route
              path="classes"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.SECRETARY]}>
                  <ClassesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="classes/:id"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.SECRETARY]}>
                  <ClassDetailPage />
                </ProtectedRoute>
              }
            />

            {/* المحاسبة */}
            <Route
              path="accounting"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.ACCOUNTANT]}>
                  <AccountingPage />
                </ProtectedRoute>
              }
            />

            {/* ✅ الطلاب غير المكتملين في الرسوم */}
            <Route
              path="incomplete-fees"
              element={
                <ProtectedRoute
                  roles={[
                    UserRole.OWNER,
                    UserRole.ACCOUNTANT,
                    UserRole.SECRETARY,
                  ]}
                >
                  <IncompleteFeesPage />
                </ProtectedRoute>
              }
            />

            {/* الملابس */}
            <Route
              path="clothes"
              element={
                <ProtectedRoute roles={[UserRole.OWNER]}>
                  <ClothesManagement />
                </ProtectedRoute>
              }
            />

            {/* الكتب */}
            <Route
              path="books"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.SECRETARY]}>
                  <BooksManagement />
                </ProtectedRoute>
              }
            />

            {/* إدارة المستخدمين */}
            <Route
              path="users"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.ACCOUNTANT]}>
                  <ManagementPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="staticFees"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.ACCOUNTANT]}>
                  <StaticFeesPage />
                </ProtectedRoute>
              }
            />
            
            <Route
              path="TeachersPage"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.ACCOUNTANT]}>
                  <TeachersPage />
                </ProtectedRoute>
              }
            />
             <Route
              path="TransportPage"
              element={
                <ProtectedRoute roles={[UserRole.OWNER, UserRole.ACCOUNTANT]}>
                  <TransportPage />
                </ProtectedRoute>
              }
            />
          </Route>

          {/* صفحة غير موجودة */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
